import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LinkCTA } from 'Src/components/buttons/LinkCTA';
import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalAction } from 'Src/feature/modal/ModalAction';
import { ModalActions } from 'Src/feature/modal/ModalActions';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';
import { ForgetForm, ForgetFormField, LoginForm, LoginFormField, useProvisionLogin } from 'Src/feature/provision/useProvisionLogin';

import styles from './ProvisionLogin.module.scss';

const ProvisionLogin: FC = () => {
  const { t } = useTranslation();
  const store = useProvisionLogin();

  return (
    <>
      <Flex alignItems="center" justifyContent="center" gap="sm" fullHeight fullWidth>
        <Copy variant="h6" value={t('provision.login.info.signIn')} />
        <LoginForm
          usedForm={store.loginForm}
          className={styles.formContainer}
          omitChangeTracking
          fullWidth
        >
          <LoginFormField
            type="email"
            name="username"
            label={t('labels.email')}
            autoComplete="username"
            fullWidth
          />
          <LoginFormField
            type="password"
            name="password"
            label={t('labels.password')}
            fullWidth
          />
        </LoginForm>
        <LinkCTA
          data-testid={'forget-pw-modal-btn'}
          onClick={store.forgetFormModal.open}
          underline
        >
          {t('forgotPassword.labels.forgotPassword')}
        </LinkCTA>
      </Flex>
      <Modal
        variant="prompt"
        color="warning"
        open={store.forgetFormModal.isOpen}
        onBackDropClick={store.forgetFormModal.close}
        aria-labelledby="forget-password-title"
        data-testid="forget-pw-modal"
      >
        <ModalHeader>
          <ModalTitle id="forget-password-title" copy={t('forgotPassword.labels.forgotPassword')}/>
        </ModalHeader>

        <ModalContent>
          <Flex>
            <Copy align="center" value={t('forgotPassword.labels.enterEmailToReset')} />
            <ForgetForm usedForm={store.forgetForm} size="sm" omitChangeTracking>
              <ForgetFormField type="email" name="email" id="name" label={t('labels.emailAddress')} />
            </ForgetForm>
          </Flex>
        </ModalContent>

        <ModalActions>
          <ModalAction
            data-testid="forget-pw-cancel-btn"
            label={t('labels.cancel')}
            onClick={store.forgetFormModal.close}
            color="secondary"
          />
          <ModalAction
            data-testid="forget-pw-submit-btn"
            color="primary"
            label={t('forgotPassword.labels.resetPassword')}
            disabled={store.disableForgetFormSubmit}
            onClick={() => {
              void store.onPasswordReset();
            }}
          />
        </ModalActions>
      </Modal>
    </>
  );
};

export { ProvisionLogin };
